import React from 'react';
import PropTypes from 'prop-types';

import DialogWithInfoLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithInfoLayout';

export default function UnavailableResultsDialog({ message, ...props }) {
  return (
    <DialogWithInfoLayout {...props} size="md" closeBtn header="Warning">
      {message}
    </DialogWithInfoLayout>
  );
}

export const typeOfUnavailableResultsDialog = 'typeOfUnavailableResultsDialog';

UnavailableResultsDialog.propTypes = {
  message: PropTypes.string,
  selfClose: PropTypes.func.isRequired,
};
